/**
 * The first form step's Back to the campaign detail page, or undefined when there is none.
 *
 * Only an embedded form with its detail page on (`enableEmbedForm`) has one: a hosted page, its
 * preview and the overlay open straight on the form, and the drawer never renders the detail page.
 * Every form passes the result to its first step's title strip (`onHeaderBack`), so this Back sits
 * in the strip like every later step's (owner call 2026-10-21).
 */
export function getDetailPageBack({
  isHostedPage,
  hostedPagePreview,
  enableEmbedForm,
  formDisplayMode,
  setParentPage,
}) {
  const hasDetailPage =
    !isHostedPage && !hostedPagePreview && enableEmbedForm && formDisplayMode !== 'overlay';
  if (!hasDetailPage || typeof setParentPage !== 'function') return undefined;
  return () => setParentPage('DETAIL_PAGE', 'back');
}
